import { Badge } from '@/components/ui/daisy';
import { useTranslation } from 'react-i18next';
import { ModalView } from '@/data/hook/question/useModalView';

type QuestionCounterProps = {
  counter: number;
  activeIndex: number;
  view: ModalView;
};
export default function QuestionCounter({
  counter,
  activeIndex,
  view,
}: QuestionCounterProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'courseLineForm.questionsTab.createQuestionModal',
  });

  const isCreateStep = view === 'create';

  const total = isCreateStep ? counter + 1 : counter;

  const current = isCreateStep ? total : activeIndex + 1;

  return (
    <Badge variant="soft" color="neutral">
      {t('questionCounter', {
        current,
        total,
      })}
    </Badge>
  );
}
